import { PaymentLinkResponseSchema } from "@billingnow/zod-schema";
import { apiClient } from "./client";

export type PaymentLinkResponse = PaymentLinkResponseSchema;

export interface GetPaymentLinkResponse {
  exists: boolean;
  paymentLink: PaymentLinkResponse | null;
}

/**
 * Generate a payment link for an invoice
 */
export const generatePaymentLink = async (invoiceId: string): Promise<PaymentLinkResponse> => {
  const response = await apiClient.post<PaymentLinkResponse>("/api/invoice-payment-token", { invoiceId });
  return response.data;
};

/**
 * Get existing payment link for an invoice (if valid)
 */
export const getPaymentLink = async (invoiceId: string): Promise<GetPaymentLinkResponse> => {
  const response = await apiClient.get<GetPaymentLinkResponse>(`/api/invoice-payment-token/${invoiceId}`);
  return response.data;
};

/**
 * Revoke payment link for an invoice
 */
export const revokePaymentLink = async (invoiceId: string): Promise<void> => {
  await apiClient.delete(`/api/invoice-payment-token/${invoiceId}`);
};

export default generatePaymentLink;
